export default {
  BASE_DOMAIN: 'http://121.36.0.132/api',
  // BASE_URL: 'http://127.0.0.1:88/',// 测试环境
  BASE_URL: '/api/',// 生产环境
  // BASE_URL: 'http://121.36.0.132/api/',
  NEUQ_SECRET_KEY: 'zxq-ticket-app',
  USER_TOKEN: 'zxq-ticket-user-token',
  USER_INFO: 'zxq-ticket-user-info',
  USER_MENU: 'zxq-ticket-user-menu',
  USER_AUTH: 'zxq-ticket-user-auth',
  SYS_CODE: 'zxq-ticket-sys-code',
  MENU_EVENT: 'zxq-ticket-menu-event',
};



// WEBPACK FOOTER //
// ./src/utils/Global.js